import React, { useMemo, useEffect } from 'react'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { OfferPackageOptionView, getCheapestSelectedPackageOptionWithDefault } from 'selectors/offerPage/offerPageSelectors'
import AdditionalGuestsPopup from 'components/Common/AdditionalGuestsPopup/AdditionalGuestsPopup'
import { includedGuestsExceededItems } from 'lib/checkout/cartReservationUtils'
import useVillasPrice from './useVillasPrice'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import PriceRowValueDiscountWithCaption from 'components/Luxkit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import * as Analytics from 'analytics/analytics'
import { useQsQueryParams } from 'hooks/useQueryParams'

interface Props {
  packageView: OfferPackageOptionView;
  offer: App.Offer;
  rooms: Array<App.Occupants>;
}

function VillasPriceDetails(props: Props) {
  const { packageView, offer, rooms } = props

  const [price, value, discount] = useVillasPrice(packageView)

  const showIncludedGuestsExceeded = useMemo(
    () =>
      !packageView?.package.roomRate?.extraGuestSurcharges.length &&
      includedGuestsExceededItems(rooms || [], packageView?.package, offer),
    [packageView, rooms, offer],
  )

  const shouldTrackPrice = !!price?.hotel
  const { searchId } = useQsQueryParams<{ searchId?: string }>()
  useEffect(() => {
    if (shouldTrackPrice && searchId && offer?.id) {
      Analytics.trackClientEvent({
        subject: `searchId:${searchId}_offerId:${offer.id}`,
        action: price.hotel.toString(),
        category: 'price_accuracy',
        type: 'operational',
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldTrackPrice, price?.hotel, offer?.id])

  return <div>
    <PriceRowPrice
      size="L"
      price={price.hotel}
      saleUnit="total"
    />
    {showIncludedGuestsExceeded && (
      <AdditionalGuestsPopup
        description="+ Extra guest surcharge"
        modalContent={packageView.package.roomPolicyDescription}
      />
    )}
    {!!value && <PriceRowValueDiscountWithCaption
      size="L"
      originalValue={value}
      discountPercentage={discount}
    />}
  </div>
}

export default withOfferPageAndReduxState((state, appState) => {
  return {
    packageView: getCheapestSelectedPackageOptionWithDefault(appState, state),
    offer: state.offer,
    rooms: state.rooms,
  }
}, VillasPriceDetails)
